import '@shared/services/i18n';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingApi from '@shared/components/loading/LoadingApi';
import Modals from '@shared/components/modal/Modals';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '@shared/styles/App.scss';
import { ToastContainer } from 'react-toastify';

export default function AdminApp() {
    // hooks
    const { i18n } = useTranslation();
    const location = useLocation();

    // Reload when token changes in another tab
    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'token') {
                window.location.reload();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // Scroll to top on route change
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location.pathname]);

    // lifecycle
    useEffect(() => {
        // Set initial language
        handleLanguageChange(i18n.language);

        // Listen for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Clean up listener on unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    // function
    const handleLanguageChange = (lng: string) => {
        document.documentElement.lang = lng;
    };

    return (
        <div className='group-admin-app'>
            <Outlet />
            <LoadingApi />
            <ToastContainer />
            <Modals />
        </div>
    );
}
